/**
 * Which package a person chose to open each type (RFC 0284 S6m).
 *
 * The sibling of `useInstalledApps`, following the same World pointer. Separate
 * from it because the two change on different clocks and are wanted in
 * different places: a picker needs the catalog, and opening a leaf needs the
 * choice.
 *
 * `undefined` for a World that has none, which is every World written before
 * this and every person who has never picked. That reads as "undecided", so a
 * lone claimant still opens its type.
 */

import type { AnyDocumentId } from '@automerge/automerge-repo/slim'
import type { WorldDoc } from '@mod/core/model'
import { useDocument } from './repo/useDocument'
import { readWorldPointer } from './world'

export function useWorldHandlers(): Record<string, string> | undefined {
  const worldId = readWorldPointer() ?? undefined
  const [worldDoc] = useDocument<WorldDoc>(worldId as AnyDocumentId | undefined)
  return worldDoc?.handlers
}
